import React from 'react';
import '../../styles/DashboardComponents.css';

// Habillage de carte générique pour les graphiques du haut de dashboard : titre +
// slot d'actions (boutons réglages/export) + panneau optionnel + corps. Extrait de
// `.sunburst-card` (UsageTaxonomySunburstReportCard), la référence visuelle du chantier
// d'harmonisation.
const ChartCard = ({ title, actions, panel, bodyClassName = 'chart-card-body', children }) => (
    <div className="chart-card">
        <div className="chart-card-header">
            <h2>{title}</h2>
            {actions && <div className="chart-card-header-actions">{actions}</div>}
        </div>
        {panel}
        <div className={bodyClassName}>{children}</div>
    </div>
);

export const ChartCardIconButton = ({ children, ...props }) => (
    <button type="button" className="chart-card-icon-btn" {...props}>
        {children}
    </button>
);

export const ChartCardButton = ({ children, ...props }) => (
    <button type="button" className="chart-card-btn" {...props}>
        {children}
    </button>
);

export default ChartCard;
